export default __webpack_public_path__ + "static/media/leciono.feb6bdba.svg";